import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStorefront = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M20.0033 11.6209V21.0038M22.0042 21.0038H1.99585M3.99668 11.6189V21.0038M6.99794 21.0038V15.5015C6.99794 15.2252 7.22189 15.0013 7.49815 15.0013H9.99919C10.2754 15.0013 10.4994 15.2252 10.4994 15.5015V21.0038M20.9147 8.99878H3.0853M14.0006 18.0025H17.0023C17.2785 18.0025 17.5023 17.7787 17.5023 17.5025V15.5013C17.5023 15.2251 17.2785 15.0013 17.0023 15.0013H14.0006C13.7245 15.0013 13.5006 15.2251 13.5006 15.5013V17.5025C13.5006 17.7787 13.7245 18.0025 14.0006 18.0025ZM7.49815 9.7491C7.49815 10.9923 6.49037 12 5.24721 12C4.00405 12 2.99626 10.9923 2.99626 9.7491V9.62205C2.99498 9.21459 3.10461 8.81446 3.3134 8.46456L5.41428 4.96811C5.77588 4.36545 6.42717 3.9967 7.12999 3.9967H16.87C17.5714 3.9981 18.2209 4.36667 18.5818 4.96811L20.6826 8.46456C20.8928 8.81406 21.0038 9.21421 21.0038 9.62205V9.7491C21.0038 10.9923 19.996 12 18.7528 12C17.5097 12 16.5019 10.9923 16.5019 9.7491C16.5019 10.9923 15.4941 12 14.251 12C13.0078 12 12 10.9923 12 9.7491C12 10.9923 10.9922 12 9.74908 12C8.50593 12 7.49815 10.9923 7.49815 9.7491Z",
		stroke: "#111827",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgStorefront);
export default ForwardRef;
